// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NotificationProperty-checkbox__tBlMy{width:var(--size-full);padding:calc(var(--size-1_5) + var(--size-0_25)) var(--size-3);outline:0;box-shadow:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": "NotificationProperty-checkbox__tBlMy"
};
export default ___CSS_LOADER_EXPORT___;
